import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=4cfeefea&"
import script from "./DocumentForm.vue?vue&type=script&lang=js&"
export * from "./DocumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports